import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorage } from '../../shared/services/local-storage.service';
import { RoutePath } from '../../shared/enums/common.enum';
import { RoleAccessService } from '../../shared/services/role-access.service';
import { hasProfileContext } from './guard.utils';

/**
 * Guest Guard - Functional guard using modern Angular patterns
 * Prevents authenticated users from accessing guest-only routes (e.g., login page)
 * 
 * @returns true if user is NOT authenticated, false otherwise (redirects to protected area)
 */
export const guestGuard: CanActivateFn = () => {
    const localStorageService = inject(LocalStorage);
    const router = inject(Router);
    const roleAccessService = inject(RoleAccessService);

    const accessToken = localStorageService.getDataByKey('accessToken');

    if (!accessToken) {
        // User is not authenticated, allow access to guest routes
        return true;
    }

    if (!hasProfileContext(localStorageService)) {
        // Token exists but profile context is missing; treat as not-authenticated.
        localStorageService.clearAllStorage();
        return true;
    }

    // User is already authenticated, redirect to protected area
    const redirectPath = roleAccessService.isSubAdmin()
      ? `/${RoutePath.DASHBOARD}`
      : `/${RoutePath.SUB_ADMIN}`;

    console.warn('Already authenticated. Redirecting to protected area.');
    return router.createUrlTree([redirectPath]);
};
